import { JobsTable } from "~/features/jobs/CompanyTable";

import { Job } from "~/types/Job";
import { companies } from "~/constants/companies";
import { CompanyInfoCard } from "~/features/companies/CompanyInfoCard";
import { Subscribe } from "~/components/Subscribe";
import { H1, H2 } from "~/components/Text";
import { ReactElement } from "react";

interface JobsPageProps {
  title: ReactElement;
  company: string;
  jobs: Job[];
  count: number;
}

export function JobsPage({ title, company, jobs, count }: JobsPageProps) {
  if (!company) return null;

  const companyInfo = companies.find(
    (c) => c.id.toLowerCase() === company.toLowerCase(),
  );

  return (
    <div className="w-full flex flex-col">
      <H1>{title}</H1>
      {count > 0 && <H2>Currently hiring {count} positions</H2>}
      <div className="flex gap-16 mt-12 mb-8 flex-wrap">
        {companyInfo && <CompanyInfoCard company={companyInfo} />}
      </div>
      {!!jobs?.length ? (
        <div className="w-full">
          <JobsTable jobs={jobs} />
        </div>
      ) : (
        <div className="my-12 w-full text-gray-200 text-xl">
          <h2>{company} is currently not hiring.</h2>
        </div>
      )}
      <br />
      <br />
      <Subscribe company={company} center id="bottom" />
    </div>
  );
}
